import * as React from 'react';

import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';

import { confirmPhone } from 'actions/account';
import { requestResend } from 'actions/otp';
import { OtpPage } from 'components/OtpPage';
import { APPLICATION_FORM_NAME } from 'constants/app';
import { validate } from 'helper/validation/otp/otpForm';
import { AccountPhoneOtpForm } from 'models/account';
import { AppState } from 'models/app';
import { OtpForm } from 'models/otp';

import './AccountPhoneSetOtp.scss';

interface StateProps {
  phone: string;
}

interface DispatchProps {
  confirmPhone: typeof confirmPhone;
  requestResend: typeof requestResend;
}

type OwnProps = RouteComponentProps<{}>;
type AccountPhoneSetOtpProps = StateProps & DispatchProps & OwnProps;

class AccountPhoneSetOtpContainer extends React.Component<AccountPhoneSetOtpProps, {}> {
  constructor(props: AccountPhoneSetOtpProps) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  render() {
    const { history, location, phone } = this.props;

    if (!phone) {
      return <Redirect to="/"/>;
    }

    return (
      <OtpPage
        form={APPLICATION_FORM_NAME}
        history={history}
        location={location}
        onResendOtp={this.props.requestResend}
        onClose={history.goBack}
        onSubmit={this.onSubmit}
        phone={phone}
        validate={validate}
      />
    );
  }

  private onSubmit(formValue: OtpForm) {
    const { phone } = this.props;
    const fullFormValue: AccountPhoneOtpForm = { ...formValue, phone };
    this.props.confirmPhone(fullFormValue);
  }
}

export const AccountPhoneSetOtp = connect<StateProps, DispatchProps, OwnProps>(
  (state: AppState) => ({
    phone: state.accountState.tempAccount.phone
  }), { confirmPhone, requestResend }
)(AccountPhoneSetOtpContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/Phone/AccountPhoneSetOtp/AccountPhoneSetOtp.tsx